// @flow
import { APP_BAR_TOGGLE_MOBILE_LOCATION_SEARCH } from 'actions/appBar';

const INITIAL_STATE = {
  mobileLocationSearchShown: false,
};

export default function reduce(
  state = INITIAL_STATE,
  { type, mobileLocationSearchShown }
) {
  switch (type) {
    case APP_BAR_TOGGLE_MOBILE_LOCATION_SEARCH:
      return {
        ...state,
        mobileLocationSearchShown,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/appBar.js